import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addAppicazione, addSiccurezza, addTrattamento, apiRequestFailure, apiRequestStart, apiRequestSuccess, deleteTrattamenti, setSingleTrattamenti, setTrattamenti } from "./trattamentiSlice";
import trattamentiApi from "../../services/trattamentiApi";

// Fetch all sensori
export const fetchTrattamenti = createAsyncThunk(
    "trattamenti/fetchTrattamenti",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await trattamentiApi.getAllTrattamenti();
            dispatch(setTrattamenti(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch Trattamenti.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);

export const fetchAppicazione = createAsyncThunk(
    "trattamenti/fetchAppicazione",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await trattamentiApi.getAppicazione();

            dispatch(addAppicazione(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to create Trattamenti.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const fetchSiccurezza = createAsyncThunk(
    "trattamenti/fetchSiccurezza",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await trattamentiApi.getSiccurezza();
            dispatch(addSiccurezza(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to create Trattamenti.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const fetchTrattamento = createAsyncThunk(
    "trattamenti/fetchTrattamento",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await trattamentiApi.getTrattamento();
            dispatch(addTrattamento(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to create Trattamenti.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);

export const createTrattamenti = createAsyncThunk(
    "trattamenti/createTrattamenti",
    async (payload, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await trattamentiApi.createTrattamenti(payload);
            toast.success(response?.data?.message)
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to create sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);

export const deleteTrattamentiByID = createAsyncThunk(
    "trattamenti/deleteParticelleByID",
    async (id, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            let res = await trattamentiApi.deleteTrattamenti(id);
            toast.success(res?.data?.message)
            dispatch(deleteTrattamenti(id))
            dispatch(apiRequestSuccess());
            return id;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to delete sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const fetchSingleTrattamenti = createAsyncThunk(
    "trattamenti/fetchSingleTrattamenti",
    async (id, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await trattamentiApi.getTrattamenti(id);
            dispatch(setSingleTrattamenti(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch sensore.";  // Handle error
            dispatch(apiRequestFailure(errorMessage));  // Dispatch API request failure
            throw new Error(errorMessage);  // Throw error for further handling
        }
    }
);

export const updateTrattamenti = createAsyncThunk(
    "trattamenti/updateTrattamenti",
    async ({ id, data }, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await trattamentiApi.updateTrattamenti(id, data);
            toast.success(response?.data?.message)
            dispatch(apiRequestSuccess());
            dispatch(fetchTrattamenti())
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to update sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);

